/**
 * Kom i gang (#294): GET /onboarding, the steps from the company's saved facts, and the caller's own
 * pause of the guide. The hub, the guide beside a page and Kontroll's waiting state read this one
 * answer. A pause changes no step (ONB-03).
 */
import { useTenant } from '@/shell/tenant';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { get, put } from './client';

export type Phase = 'opprett' | 'kontroller' | 'rapporter';
export type StepKey =
  | 'arbeidsmate'
  | 'ansatte'
  | 'arbeidstid'
  | 'vaktplan'
  | 'tilgang'
  | 'registrert'
  | 'godkjent'
  | 'rapport';
export interface Step {
  key: StepKey;
  phase: Phase;
  done: boolean;
  /** how many are left, where the step is about people */
  count?: number;
}
export interface Onboarding {
  mode: 'rota' | 'time';
  start_date: string | null;
  revision: number;
  facts: {
    people: number;
    missing_hours: number;
    uninvited: number;
    logged_in: number;
    published: number;
    first_published: string | null;
    worked: number;
    approved: number;
    reports: number;
  };
  steps: Step[];
  paused_at: string | null;
}

const KEY = (t?: number) => ['onboarding', t];

export function useOnboarding(enabled = true) {
  const { tenant } = useTenant();
  return useQuery({
    queryKey: KEY(tenant?.id),
    queryFn: () => get<Onboarding>('/onboarding'),
    enabled: enabled && !!tenant,
  });
}

export function useGuidePause() {
  const qc = useQueryClient();
  const { tenant } = useTenant();
  return useMutation({
    mutationFn: (paused: boolean) => put<{ paused_at: string | null }>('/onboarding/guide', { paused }),
    onSuccess: (r) =>
      qc.setQueryData<Onboarding>(KEY(tenant?.id), (o) => (o ? { ...o, paused_at: r.paused_at } : o)),
  });
}
